/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:969a629e-fbc8-4cdb-8912-ad014dcc2152",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6TpTlgg0z",
    "aws_user_pools_web_client_id": "6n67j51eg99hsm6dri44jprdr7",
    "oauth": {},
    "aws_user_files_s3_bucket": "vetassistprofpics10220-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
